document.addEventListener("DOMContentLoaded", function() {
    
    document.querySelector(".product-listing").addEventListener("click", function(e) {
        if (e.target.classList.contains('product-view')) {
            const swiperContainer = document.querySelector(".product-listing-slider");
            const swiperWrapper = document.querySelector("#product-grid");
            
            const swiperSlides = document.querySelectorAll("#product-grid .product ");
            const swiperController = document.querySelector(".swiper-controller");

            if (isSwiperEnabled) {
                // Disable Swiper
                swiperContainer.style.width = "auto";
                swiperContainer.classList.remove("swiper-container");
                swiperWrapper.classList.remove("swiper-wrapper");
                swiperWrapper.classList.add("row");
                swiperSlides.forEach(function(slide) {
                    slide.style.width = "";
                    slide.classList.remove("swiper-slide");
                    slide.classList.add("col-md-4");
                });
    
                swiperController.classList.add("swiper-disable");
                
                isSwiperEnabled = false;
                e.target.textContent = 'View Less';
            } else {
                
                swiperContainer.classList.add("swiper-container");
                swiperWrapper.classList.add("swiper-wrapper");
                swiperWrapper.classList.remove("row");
                swiperSlides.forEach(function(slide) {
                    slide.classList.remove("col-md-4");
                    slide.classList.add("swiper-slide");
                });
    
                swiperController.classList.remove("swiper-disable");
                
                isSwiperEnabled = true;
                e.target.textContent = 'View More';
            }
        }
    });
});